<template>
    <div class="resumeOther cert">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>证书</h1>
                <p>{{certSize}}/10</p>
            </el-col>
            <el-col :span="20">
                <div v-for="(item,index) in resumeInfo.certList" class="workExpList">

                    <div v-if="!resumeEditStatus" class="editBtn">
                        <!--编辑按钮-->
                        <el-button slot="reference" type="text" icon="el-icon-edit-outline"
                                   @click="edit(item)" v-has-permi="['resume:cert:edit']"></el-button>

                        <!--删除按钮-->
                        <el-popconfirm title="确认删除证书？"
                                       placement="top-start"
                                       @confirm="deleteCert(item.id)"
                                       icon="el-icon-info"
                                       icon-color="red"
                                       v-has-permi="['resume:cert:delete']">
                            <el-button slot="reference" type="text" icon="el-icon-delete"></el-button>
                        </el-popconfirm>
                    </div>

                    <div>
                        <!--编辑状态-->
                        <div v-if="editStatus.id==item.id && editStatus.status">
                            <div v-if="resumeEditStatus && certEditStatus">
                                <cert-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus"></cert-form>
                            </div>
                        </div>

                        <div v-else class="resumeContent">
                            <el-row>
                                <el-col :span="12">
                                    <p><b>{{item.getTime}}</b></p>
                                </el-col>
                                <el-col :span="12">
                                    <p style="width: 80%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                        <el-tooltip popper-class="certImgTip" effect="light" placement="bottom-start">
                                            <b>{{item.name}}</b>
                                            <template #content v-if="item.attachment">
                                                <div class="certImg">
                                                    <img :src="location(item.attachment)"/>
                                                </div>
                                            </template>
                                        </el-tooltip>
                                    </p>
                                </el-col>
                            </el-row>
                            <!--<el-popover-->
                                    <!--placement="bottom"-->
                                    <!--width="400"-->
                                    <!--trigger="hover">-->
                                <!--&lt;!&ndash;<img :src="location(item.attachment)" width="30%"/>&ndash;&gt;-->
                                <!--<img :src="location" width="30%"/>-->
                                <!--<el-button slot="reference">click 激活</el-button>-->
                            <!--</el-popover>-->

                        </div>
                    </div>

                </div>

                <!--新增简历证书表单-->
                <div v-if="!editStatus.status && resumeEditStatus && certEditStatus">
                    <cert-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus" @editStatus="getEditStatus"></cert-form>
                </div>

                <div v-if="certSize<10 && !resumeEditStatus" v-has-permi="['resume:cert:add']" class="addExp">
                    <el-button @click="add()" icon="el-icon-plus">添加证书</el-button>
                </div>

            </el-col>
        </el-row>
    </div>
</template>
<script>
    import CertForm from './Form/CertForm.vue';
    import {deleteCert} from '@/api/resume';
    export default {
        name: 'cert',
        props: ['resumeInfo'],
        data () {
            return {
                // 表单编辑状态
                editStatus: {
                    id: 0,
                    status: false,
                },
                form: {
                    type: '1+x技能证书',
                },
            };
        },
        computed: {
            location(){
                return function (attachment){
                    let imagePath = encodeURI(attachment);
                    return `/files?imagePath=${imagePath}`;
                }
            },
            // 简历编辑状态
            resumeEditStatus(){
                return this.$store.state.index.resumeEditStatus;
            },
            // 简历工作经历编辑状态
            certEditStatus(){
                return this.$store.state.index.certEditStatus;
            },
            // 简历工作经历列表数量
            certSize(){
                return this.size();
            }
        },
        methods: {

            // 计算简历工作经历数量
            size(){
                var certSize = 0;
                for(var i in this.resumeInfo.certList) {
                    certSize++;
                }
                return certSize;
            },
            // 表单进入编辑状态
            edit(item){
                this.add();
                this.form = Object.assign({}, item);
                this.editStatus.id = item.id;
                this.editStatus.status = true;
            },
            // 简历工作经历表单切换至编辑状态
            add() {
                this.form = {type: '1+x技能证书'};
                this.$store.commit('changeResumeEditStatus', true);
                this.$store.commit('changeCertEditStatus', true);
            },
            // 根据id删除工作经历
            deleteCert(id) {
                deleteCert(id).then(res => {
                    this.$store.commit('changeResumeRefreshFlag', true);
                })
            },
            getEditStatus(data) {
                this.editStatus = data;
            }
        },
        components: {
            CertForm,
        }
    }
</script>
